import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {isPlatformBrowser, isPlatformServer, Location} from '@angular/common';
import {makeStateKey, TransferState} from '@angular/platform-browser';
import {Router} from '@angular/router';
import {HttpUtil} from '../../shared/service/common.http';
import {NzI18nService} from 'ng-zorro-antd';
import {catchError, tap} from 'rxjs/operators';
import {TranslateService} from '@ngx-translate/core';
import {Observable} from 'rxjs';

import {AdressService} from '../../shared/service/adress.service';
import {HandleError, HttpErrorHandler} from '../../shared/service/http-error-handler.service';
import {GlobalCacheService} from '../../shared/service/global-cache.service';
import {CommonServiceService} from '../../shared/service/common-service.service';
import {EventBusService} from '../../shared/service/event-bus.service';
import {UtilService} from 'src/app/shared/utils/util.service';
import {globalConst} from 'src/app/shared/constant/constant';
import {ModalConfigService} from '../../shared/utils/modal-config.service';

@Injectable({
  providedIn: 'root'
})
export class TemplateService {
  constructor(
    public router: Router,
    private http: HttpUtil,
    private httpErrorHandler: HttpErrorHandler,
    private state: TransferState,
    private transferState: TransferState,
    private addressService: AdressService,
    private globalCacheService: GlobalCacheService,
    public commonService: CommonServiceService,
    public eventBusService: EventBusService,
    private utilService: UtilService,
    private NzI18n: NzI18nService,
    private translate: TranslateService,
    private modalConfigService: ModalConfigService,
    @Inject(PLATFORM_ID) private platformId,
  ) {
    this.handleError = httpErrorHandler.createHandleError('TemplateService');
  }

  private handleError: HandleError;

  // 获取商户配置
  async getMerchantConfig(): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    // const DATA_KEY = makeStateKey<any>('merchantConfig');
    // if (isPlatformBrowser(this.platformId)) {
    //   console.log('获取首页数据-客户端运行');
    //   if (this.transferState.hasKey(DATA_KEY)) {
    //     return this.transferState.get(DATA_KEY, null);
    //   }
    // } else if (isPlatformServer(this.platformId)) {
    //   console.log('获取首页数据-服务端运行');
    //   const data = this.transferState.get(DATA_KEY, null);
    //   if (data) {
    //     this.transferState.remove(DATA_KEY);
    //   }
    // }
    const api = this.addressService.getMerchantConfig(appId);
    const serverData = await this.http
      .get(api)
      .pipe(catchError(this.handleError('getMerchantConfig', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.transferState.set(DATA_KEY, serverData);
    return serverData;
  }

  // 获取首页数据
  async getHomeData(): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    const lang = this.commonService.getLocalStorageByKey('language') || '';
    // const DATA_KEY = makeStateKey<any>('home-' + appId);
    // if (isPlatformBrowser(this.platformId)) {
    //   console.log('获取首页数据-客户端运行');
    //   if (this.transferState.hasKey(DATA_KEY)) {
    //     return this.transferState.get(DATA_KEY, null);
    //   }
    // } else if (isPlatformServer(this.platformId)) {
    //   console.log('获取首页数据-服务端运行');
    //   const data = this.transferState.get(DATA_KEY, null);
    //   if (data) {
    //     this.transferState.remove(DATA_KEY);
    //   }
    // }
    const api = this.addressService.getHome(appId, lang);
    const serverData = await this.http
      .get(api)
      .pipe(catchError(this.handleError('getHome', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.transferState.set(DATA_KEY, serverData);
    return serverData;
  }

  // 获取指定模板数据
  async getTemplateData(id): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    const lang = this.commonService.getLocalStorageByKey('language') || '';
    // const DATA_KEY = makeStateKey<any>('template-' + id);
    // if (isPlatformBrowser(this.platformId)) {
    //   console.log('获取首页数据-客户端运行');
    //   if (this.transferState.hasKey(DATA_KEY)) {
    //     return this.transferState.get(DATA_KEY, null);
    //   }
    // } else if (isPlatformServer(this.platformId)) {
    //   console.log('获取首页数据-服务端运行');
    //   const data = this.transferState.get(DATA_KEY, null);
    //   if (data) {
    //     this.transferState.remove(DATA_KEY);
    //   }
    // }
    const api = this.addressService.getTemplateById(id, appId, lang);
    const serverData = await this.http
      .get(api)
      .pipe(catchError(this.handleError('getTemplateData', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(DATA_KEY, serverData);
    return serverData;
  }

  // 获取文章详情数据
  async getContentById(id): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    const lang = this.commonService.getLocalStorageByKey('language') || '';
    // const CONTENT_KEY = makeStateKey<any>('content-' + id);
    // if (this.state.hasKey(CONTENT_KEY)) {
    //   return this.state.get(CONTENT_KEY, null);
    // }
    const api = this.addressService.getContentById(id, appId, lang);
    const serverData = await this.http
      .get(api)
      .pipe(catchError(this.handleError('getHome', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }

  // 获取文章详情数据 (受IP限制)(公安局项目)
  async getIpContentById(id): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    const lang = this.commonService.getLocalStorageByKey('language') || '';
    // const CONTENT_KEY = makeStateKey<any>('content-' + id);
    // if (this.state.hasKey(CONTENT_KEY)) {
    //   return this.state.get(CONTENT_KEY, null);
    // }
    const api = this.addressService.getIpContentById(id, appId, lang);
    const serverData = await this.http
      .get(api)
      .pipe(catchError(this.handleError('getHome', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }


  // 条件查询内容列表
  async getContentList(params): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    params = { ...(params || {}) };
    const skipLang = params.skipLang === true;
    delete params.skipLang;
    if (!skipLang) {
      params.lang = this.commonService.getLocalStorageByKey('language') || '';
    }
    // const DATA_KEY = makeStateKey<any>(`getContentList-${params.page}-${params.title}-${params.classifyId}`);
    // if (isPlatformBrowser(this.platformId)) {
    //   console.log('仅在客户端运行');
    //   if (this.transferState.hasKey(DATA_KEY)) {
    //     return this.transferState.get(DATA_KEY, null);
    //   }
    // } else if (isPlatformServer(this.platformId)) {
    //   console.log('仅在服务端运行-内容列表');
    //   const data = this.transferState.get(DATA_KEY, null);
    //   if (data) {
    //     this.transferState.remove(DATA_KEY);
    //   }
    // }
    const api = this.addressService.getContentList(appId);
    const serverData = await this.http
      .get(api, params)
      .pipe(catchError(this.handleError('getContentList', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(DATA_KEY, serverData);
    return serverData;
  }

  // 分类列表接口
  async getClassifyList(params): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    params.lang = this.commonService.getLocalStorageByKey('language') || '';

    // const DATA_KEY = makeStateKey<any>('getClassifyList');
    // if (isPlatformBrowser(this.platformId)) {
    //   console.log('仅在客户端运行');
    //   if (this.transferState.hasKey(DATA_KEY)) {
    //     return this.transferState.get(DATA_KEY, null);
    //   }
    // } else if (isPlatformServer(this.platformId)) {
    //   console.log('仅在服务端运行-分类列表接口');
    //   const data = this.transferState.get(DATA_KEY, null);
    //   if (data) {
    //     this.transferState.remove(DATA_KEY);
    //   }
    // }
    const api = this.addressService.getClassifyList(appId);
    const serverData = await this.http
      .get(api, params)
      .pipe(catchError(this.handleError('getClassifyList', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(DATA_KEY, serverData);
    return serverData;
  }

  // 条件查询省份列表 /a/u/province/search
  async getProvinceList(params): Promise<any> {
    const serverData = await this.http
      .get(this.addressService.getProvinceList(), params)
      .pipe(catchError(this.handleError('getProvinceList', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }


// 提交联系我们接口
  async addVisitLog(params): Promise<any> {
    const serverData = await this.http
      .post(this.addressService.addVisitLog(), params)
      .pipe(catchError(this.handleError('addVisitLog', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }

// 根据溯源码获取详情
  async getCodeDetail(code: string): Promise<any> {
    const serverData = await this.http
      .get(this.addressService.getCodeDetail(code))
      .pipe(catchError(this.handleError('getCodeDetail', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }

  // 更新溯源码状态
  async updateCodeStatus(id: string): Promise<any> {
    const serverData = await this.http
      .put(this.addressService.updateCodeStatus(id))
      .pipe(catchError(this.handleError('updateCodeStatus', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }

  // 貔貅接口
  async getHoneypot(params): Promise<any> {
    const serverData = await this.http
      .get(this.addressService.getHoneypot(), params)
      .pipe(catchError(this.handleError('getHoneypot', [])))
      .toPromise().then((res: any) => res);
    return serverData;
  }


  // 子女信息
  async getChildInformationList(params): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    // const lang = this.commonService.getLocalStorageByKey('language') || '';
    // params.lang = lang;

    // const CONTENT_KEY = makeStateKey<any>('getClassifyList-');
    // if (this.state.hasKey(CONTENT_KEY)) {
    //   return this.state.get(CONTENT_KEY, null);
    // }

    const serverData = await this.http
      .get(this.addressService.getChildInformationList(appId), params)
      .pipe(catchError(this.handleError('getClassifyList', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }


  // 联系地址
  async shippingAddressSearch(params): Promise<any> {
    const appId = this.globalCacheService.appId || '';
    // const lang = this.commonService.getLocalStorageByKey('language') || '';
    // params.lang = lang;

    // const CONTENT_KEY = makeStateKey<any>('getClassifyList-');
    // if (this.state.hasKey(CONTENT_KEY)) {
    //   return this.state.get(CONTENT_KEY, null);
    // }

    const serverData = await this.http
      .get(this.addressService.shippingAddressSearch(appId), params)
      .pipe(catchError(this.handleError('getClassifyList', [])))
      .toPromise().then((res: any) => res.code === 0 ? res : Promise.reject(res));

    // this.state.set(CONTENT_KEY, serverData);
    return serverData;
  }


  /**
   * 合并分类列表数据
   * @param componentBaseClassifyList 二级分类数据
   * @param templateData 页面模板数据
   */
  arrayTransformclassifyMap(componentBaseClassifyList, templateData): object {
    let map = {};
    const classifyIdList = [];
    const classificationListData = this.globalCacheService.classificationListData;

    if (classificationListData) {
      map = classificationListData;
    }
    if (componentBaseClassifyList instanceof Array) {
      if (templateData && templateData.moduleJson) {
        for (const iterator of JSON.parse(templateData.moduleJson).pageJSON) {
          if (iterator.data && iterator.data.classificationId) {
            classifyIdList.push(iterator.data.classificationId);
          }
        }
      }
      for (const iterator of classifyIdList) {
        map[iterator] = componentBaseClassifyList.filter((father) => father.pid === iterator);
      }
    }
    return map;
  }

  /**
   * 模板数据 转map格式
   * @param template 页面模板
   * @param key key值
   */
  templateTransformMap(template, key): object {
    let map = {};
    const templateMap = this.globalCacheService.templateDataMap;
    if (templateMap) {
      map = templateMap;
    }
    if (template) {
      map[template[key]] = template;
    }
    return map;
  }

  /**
   * 合并列表数据
   * @param classifyDate classifyContentsMap
   */
  classifyContentsMap(classifyDate): object {
    let classifyContentsMap;
    if (this.globalCacheService.classifyContentsMap) {
      classifyContentsMap = this.globalCacheService.classifyContentsMap;
      if (classifyContentsMap instanceof Object) {
        for (const key in classifyDate) {
          if (classifyDate[key]) {
            classifyContentsMap[key] = classifyDate[key];
          }
        }
      }
    } else {
      classifyContentsMap = classifyDate;
    }
    return classifyContentsMap;
  }

  /**
   * 储存数据
   * 将数据存入全局缓存服务中 globalCacheService 中 再由各组件自行取数据渲染
   * @param templeateList  模板列表
   * @param classifyContentsMap 模板数据
   */
  setlocalStorage(templateDataMap, classifyContentsMap, classificationListData): void {
    this.globalCacheService.templateDataMap = templateDataMap;
    this.globalCacheService.classifyContentsMap = classifyContentsMap;
    this.globalCacheService.classificationListData = classificationListData;
  }

  /**
   * 退出登录
   */
  async removeLocalStorage(navigationComponent?: any): Promise<void> {
    this.commonService.removeLocalStorageByKey(['userImg', 'userName', 'userInfo', 'login', 'organization']);
    this.eventBusService.logOutEvent.next(null);
    const appId = this.globalCacheService.appId;
    const homeQueryParams = appId ? {appid: appId} : {};
    if (!(navigationComponent && navigationComponent.rules && navigationComponent.rules.loginCheck === true)) {
      this.router.navigate(['home'], {queryParams: homeQueryParams});
      return;
    }

    const merchantConfig = this.commonService.getLocalStorageByKey('merchantConfig', {});
    const websiteConfig = merchantConfig && merchantConfig.websiteConfig;
    const loginTemplateId = websiteConfig && websiteConfig.loginTemplateId;
    if (loginTemplateId) {
      const queryParams: any = {templateId: loginTemplateId, ...homeQueryParams};
      this.router.navigate(['detail'], {queryParams, replaceUrl: true});
      return;
    }
    this.modalConfigService.errMsg('登录页模板未配置，请联系管理员。');
    this.router.navigate(['home'], {queryParams: homeQueryParams, replaceUrl: true});
  }


  setI18NAndMultiLanguage(config) {
    const { module: { content: { multiLanguage = [], languageMapper = [] } = {} } = {} } = this.utilService.getJSONParse(config);
    this.commonService.setLocalStorageByKey('multiLanguage', JSON.stringify((multiLanguage || [])));
    this.commonService.setLocalStorageByKey('languageMapper', JSON.stringify((languageMapper || [])));
  }

  setI18NDefaultConfig(config) {
    const prevDefaultLanguage = this.commonService.getLocalStorageByKey('prevDefaultLanguage') || '';
    const { module: { content: { defaultLanguage = 'Cn' } = {} } = {} } = this.utilService.getJSONParse(config);
    if(prevDefaultLanguage == defaultLanguage){
      return
    }
    // 设置最新默认语言，若后台更改则会进行重新设置默认语言，否则不会触发以下代码
    this.commonService.setLocalStorageByKey('prevDefaultLanguage', defaultLanguage);
    const lang = this.commonService.getLocalStorageByKey('titleLang') || '';
    if (defaultLanguage === lang) return
    let tempLang = ''
    const languageMapper = this.utilService.getJSONParse(this.commonService.getLocalStorageByKey('languageMapper'), []);
    if (languageMapper.length !== 0) {
      tempLang = languageMapper.find(item => item.value === defaultLanguage)?.ant;
    } else {
      tempLang = globalConst.internationalizationMapping[defaultLanguage];
    }
    console.log(tempLang, 'tempLang----')
    this.setI18NConfig(tempLang);
    return setTimeout(() => {
      location.reload();
    }, 200);
  }

  setI18NConfig(lang: string): void {
    try {
      if (lang) {
        let mapper: any = {};
        const languageMapper = this.utilService.getJSONParse(this.commonService.getLocalStorageByKey('languageMapper'), []);
        // 若存在languageMapper多语言映射，则优先使用languageMapper多语言映射
        if (languageMapper.length !== 0) {
          mapper = languageMapper.find(item => item.ant === lang)
          if (!mapper) {
            mapper = languageMapper.find(item => item.value === 'Cn')
          }
          mapper.interior = mapper.value === 'Cn' ? '' : mapper.value
        } else {
          mapper = globalConst.internationalizationMappingRelation[lang];
        }
        const {interior = '', ant = 'zh_Cn', value = 'Cn'} = mapper;
        // const {interior, ant} = globalConst.internationalizationMappingRelation[lang];
        if (isPlatformBrowser(this.platformId)) {
          // ng-zorro-antd 组件库国际化
          this.NzI18n.setLocale(ant);
          // 静态文案国际化
          this.translate.use(lang);
        }
        this.commonService.setLocalStorageByKey('lang', interior);
        this.commonService.setLocalStorageByKey('titleLang', value); // 中文Cn
        this.commonService.setLocalStorageByKey('language', interior);
        this.commonService.setLocalStorageByKey('I18N', lang);
      }
    } catch (error) {
      console.log('(template.service.ts:405) error', error);
    }
  }
}
